import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { ProductCard } from '../browse-products-by-categories/product-card/product-card.component';
import { useReplenishOverview } from './replenish-overview.controller';

export const ReplenishOverview = () => {
    const viewProps = useReplenishOverview();

    return (
        <WizardScreenContainer
            header={{
                title: (
                    <FormattedMessage
                        defaultMessage='Replenish products'
                        id='replenish-overview.replenish-detail.title'
                    />
                )
            }}>
            <div className='text-foreground-default flex w-full flex-col gap-3 font-medium'>
                <span>
                    <FormattedMessage
                        defaultMessage='Replenish the following products'
                        id='replenish-overview.replenish-following-products'
                    />
                </span>
                {/**TODO: Add search later */}
                {/* <SearchTextInput
                    className='w-full'
                    placeholder={viewProps.intl.formatMessage({ defaultMessage: 'Find a product', id: 'replenish-overview.search-products.placeholder' })}
                    onChange={(e) => viewProps.onFetch({ product_name: e, name: e })}
                /> */}
                <div className='flex flex-col gap-2'>
                    {viewProps.replenishment.map((product) => (
                        <ProductCard
                            onClick={(prod) => viewProps.selectProduct({ ...product, product: prod })}
                            key={product.id}
                            product_id={product.product_id}
                            variant='stock'
                            fill_amount={product.proposed_quantity}
                            current_stock={product.quantity}
                            min_stock={product.required_min}
                            max_stock={product.required_max}
                            replenishment={product}
                        />
                    ))}
                </div>
            </div>
        </WizardScreenContainer>
    );
};
